import AppConfig from "../AppConfig";
const filterMenuItems = (menuItems, toExclude) => menuItems.filter((item) => !toExclude.includes(item.path));
export const filterCloudMenuItems = (menuItems, toExclude) => {
  if (!AppConfig.isCloud()) {
    return menuItems;
  }
  return filterMenuItems(menuItems, toExclude);
};
export default filterMenuItems;
